import React from "react";
import { DateModal } from "../Date/index.js";
import useSegment from "./useSegment.js";
const ChangeFlightSegmentVertical = () => {
    const { segments } = useSegment();
    return (React.createElement(React.Fragment, null, segments.map((_, idx) => (React.createElement(DateModal, { segmentIndex: idx, key: idx })))));
};
export default ChangeFlightSegmentVertical;
